import { render, staticRenderFns } from "./LabelCornerBottomLeftIcon.vue?vue&type=template&id=2fe95ada&"
import script from "./LabelCornerBottomLeftIcon.vue?vue&type=script&lang=js&"
export * from "./LabelCornerBottomLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports